import { render } from "./SelectUser.vue?vue&type=template&id=280b1e72"
import script from "./SelectUser.vue?vue&type=script&lang=js"
export * from "./SelectUser.vue?vue&type=script&lang=js"

import "./SelectUser.vue?vue&type=style&index=0&id=280b1e72&lang=css"

import exportComponent from "/var/www/dt_project_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__